import { whiteList, trackSignalEvent } from 'services/utility/analytics'
import { actions as cmsActions } from 'services/cms-state'
import { getPageName } from 'services/utility'
import { GET_PROFILE_FAILURE, GET_PROFILE_SUCCESS, SIGN_OUT_SUCCESS } from '../app-state/profile/constants'
import { setAnalyticsMetadata } from '../utility/analytics'

const { CMS_API_FILE_NOT_FOUND, CMS_API_FAILURE } = cmsActions

const analytics = ({ getState }) => next => (action) => {
  const returnValue = next(action)
  const { type } = action
  const pageName = getPageName()
  const state = getState()
  const { metaContent: { configs: { title = '' } = {} } = {}, mainContent = [] } = state.cmsData
  const page = title || pageName
  if (whiteList.indexOf(action.type) > -1) {
    switch (type) {
      case CMS_API_FILE_NOT_FOUND:
        trackSignalEvent('triggerOmniture404', { pageName })
        break
      case CMS_API_FAILURE:
        trackSignalEvent('triggerOmnitureBackSoon', { pageName })
        break
      case GET_PROFILE_SUCCESS:
        setAnalyticsMetadata({ isSignedIn: true })
        if (mainContent.length) {
          trackSignalEvent('triggerOmnitureAsdaDotCom', { pageName: page })
        }
        break
      case GET_PROFILE_FAILURE:
        setAnalyticsMetadata({ isSignedIn: false })
        if (mainContent.length) {
          trackSignalEvent('triggerOmnitureAsdaDotCom', { pageName: page })
        }
        break
      case SIGN_OUT_SUCCESS:
        setAnalyticsMetadata({ isSignedIn: false })
        break
      default:
        break
    }
  }
  return returnValue
}

export default analytics



// WEBPACK FOOTER //
// ./services/middle-ware/analytics.js